import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import HeaderText from "../../../components/Nurse/NurseHeaderText";
import "./EMRRegister.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faMinus } from "@fortawesome/free-solid-svg-icons";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { getServerBaseUrl } from "../../../utils/portConfig";

const EMRRegister = () => {
  const sample4 = [
    { code: "D3063", testName: "당화혈색소 검사" },
    { code: "", testName: "풍진 검사" },
  ];

  const [EMRData, setEMRData] = useState([]);
  const [patientId, setPatientId] = useState(0);
  const [sangAddData, setSangAddData] = useState({});
  const [testAddData, setTestAddData] = useState({});
  const [preAddData, setPreAddData] = useState({});
  const [sangCodeData, setSangCodeData] = useState([]); // 자동완성 기능
  const [sangAutoTemp, setSangAutoTemp] = useState([]); // 자동완성 기능
  const [sangSearchTerm, setSangSearchTerm] = useState(""); // 자동완성 기능
  const [testCodeData, setTestCodeData] = useState([]); // 자동완성 기능(검사)
  const [testAutoTemp, setTestAutoTemp] = useState([]); // 자동완성 기능(검사)
  const [testAutoData, setTestAutoData] = useState({}); // 자동완성 기능(검사)
  const [testSearchTerm, setTestSearchTerm] = useState(""); // 자동완성 기능(검사)
  const [preCodeData, setPreCodeData] = useState([]); // 자동완성 기능(처방)
  const [preAutoTemp, setPreAutoTemp] = useState([]); // 자동완성 기능(처방)
  const [preSearchTerm, setPreSearchTerm] = useState(""); // 자동완성 기능(처방)
  const [patientList, setPatientList] = useState([]);
  const [patientInfo, setPatientInfo] = useState({});
  const [patientVITAL, setPatientVITAL] = useState({});
  const [patientSang, setPatientSang] = useState([]);
  const [patientTest, setPatientTest] = useState([]);
  const [patientPrescription, setPatientPrescription] = useState([]);
  const [isOpenPatientInfo, setIsOpenPatientInfo] = useState(false);
  const [showPreviewSave, setShowPreviewSave] = useState(false);
  const [arrowPatientList, setArrowPatientList] = useState(<FontAwesomeIcon icon={faMinus} />);
  const [arrowBasicInfo, setArrowBasicInfo] = useState(<FontAwesomeIcon icon={faMinus} />);
  const [arrowVital, setArrowVital] = useState(<FontAwesomeIcon icon={faMinus} />);
  const [arrowSang, setArrowSang] = useState(<FontAwesomeIcon icon={faMinus} />);
  const [arrowTest, setArrowTest] = useState(<FontAwesomeIcon icon={faMinus} />);
  const [arrowPre, setArrowPre] = useState(<FontAwesomeIcon icon={faMinus} />);
  const [searched, setSearched] = useState(false);

  const token = localStorage.getItem("token");
  const hospitalId = localStorage.getItem("hospitalId");
  const userId = localStorage.getItem("userid"); //접속한 의사 ID
  const today = new Date().toISOString().split("T")[0]; // 오늘 날짜를 "YYYY-MM-DD" 형식으로 변환

  useEffect(() => {
    getSTPCodeMaster();
  }, []);

  // 자동완성 onChange
  const handleSangAutoInputChange = (e) => {
    const { value } = e.target;
    setSangSearchTerm(value);
    const filteredOptions = sangCodeData.filter(
      (option) => (option.code.toUpperCase().includes(value.toUpperCase()) || option.codeName.includes(value)) && e.target.value !== ""
    );
    if (filteredOptions.length === 1) {
      setSangAddData(filteredOptions[0]);
    }
    setSangAutoTemp(filteredOptions);
  };

  const handleTestAutoInputChange = (e) => {
    const { value } = e.target;
    setTestSearchTerm(value);
    const filteredOptions = testCodeData.filter(
      (option) =>
        ((option.testCode !== null && option.testCode !== undefined && option.testCode.toUpperCase().includes(value.toUpperCase())) ||
          (option.masterName !== null && option.masterName !== undefined && option.masterName.toUpperCase().includes(value.toUpperCase())) ||
          (option.testName !== null && option.testName !== undefined && option.testName.toUpperCase().includes(value.toUpperCase()))) &&
        e.target.value !== ""
    );
    if (filteredOptions.length === 1) {
      setTestAddData(filteredOptions[0]);
    }
    setTestAutoTemp(filteredOptions);
  };

  const handlePreAutoInputChange = (e) => {
    const { value } = e.target;
    setPreSearchTerm(value);
    const filteredOptions = preCodeData.filter(
      (option) =>
        ((option.code !== null && option.code !== undefined && option.code.toUpperCase().includes(value.toUpperCase())) ||
          (option.codeName !== null && option.codeName !== undefined && option.codeName.toUpperCase().includes(value.toUpperCase()))) &&
        e.target.value !== ""
    );
    if (filteredOptions[0]) {
      setPreAddData(filteredOptions[0]);
    }
    setPreAutoTemp(filteredOptions);
  };

  const handleSangAutoCompleteSelect = (selectedOption) => {
    console.log("select된 자동완성 텍스트(sang)::", selectedOption);
    setSangAddData(selectedOption);
    // 새로운 배열을 생성하여 기존의 patientSang 배열과 새로운 값을 합칩니다.
    const updatedPatientSang = [
      ...patientSang,
      { patientId: patientId, medicalChargeCode: selectedOption.code, medicalChargeCodeKo: selectedOption.codeName, ruleOut: "N" },
    ];

    // setState나 useState를 통해 patientSang 상태를 업데이트합니다.
    setPatientSang(updatedPatientSang);
    setSangSearchTerm("");
    setSangAutoTemp([]);
  };

  const handleTestAutoCompleteSelect = (selectedOption) => {
    console.log("select된 자동완성 텍스트(test)::", selectedOption);
    setTestAddData(selectedOption);
    setTestAutoData(selectedOption);
    const updatedPatientTest = [
      ...patientTest,
      { patientId: patientId, insuranceClaimCode: selectedOption.testCode, medicalChargeNameKo: selectedOption.testName },
    ];

    setPatientTest(updatedPatientTest);
    setTestSearchTerm("");
    setTestAutoTemp([]);
  };

  const handlePreAutoCompleteSelect = (selectedOption) => {
    console.log("select된 자동완성 텍스트(pre)::", selectedOption);
    setPreAddData(selectedOption);
    const updatedPatientPrescription = [
      ...patientPrescription,
      { patientId: patientId, insuranceClaimCode: selectedOption.code, medicalChargeNameKo: selectedOption.codeName, type: selectedOption.type },
    ];

    setPatientPrescription(updatedPatientPrescription);
    setPreSearchTerm("");
    setPreAutoTemp([]);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "birthday") {
      if (/\d+/g.test(value)) {
        e.target.value = value.replace(/^(\d{4})(\d{2})(\d{2})$/, "$1.$2.$3");
        const formattedValue = value.replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3");
        setEMRData({
          ...EMRData,
          [name]: formattedValue,
        });
      } else {
        e.target.value = "";
        setEMRData({
          ...EMRData,
          [name]: e.target.value,
        });
      }
    } else {
      setEMRData({
        ...EMRData,
        [name]: value,
      });
    }
  };

  const pageSpredOrNot = (arrowText, flag) => {
    if (arrowText.type === FontAwesomeIcon && arrowText.props.icon === faPlus) {
      if (flag === "환자목록") {
        setArrowPatientList(<FontAwesomeIcon icon={faMinus} />);
      } else if (flag === "기본정보") {
        setArrowBasicInfo(<FontAwesomeIcon icon={faMinus} />);
      } else if (flag === "바이탈") {
        setArrowVital(<FontAwesomeIcon icon={faMinus} />);
      } else if (flag === "상병") {
        setArrowSang(<FontAwesomeIcon icon={faMinus} />);
      } else if (flag === "검사") {
        setArrowTest(<FontAwesomeIcon icon={faMinus} />);
      } else if (flag === "처방") {
        setArrowPre(<FontAwesomeIcon icon={faMinus} />);
      }
    } else {
      if (flag === "환자목록") {
        setArrowPatientList(<FontAwesomeIcon icon={faPlus} />);
      } else if (flag === "기본정보") {
        setArrowBasicInfo(<FontAwesomeIcon icon={faPlus} />);
      } else if (flag === "바이탈") {
        setArrowVital(<FontAwesomeIcon icon={faPlus} />);
      } else if (flag === "상병") {
        setArrowSang(<FontAwesomeIcon icon={faPlus} />);
      } else if (flag === "검사") {
        setArrowTest(<FontAwesomeIcon icon={faPlus} />);
      } else if (flag === "처방") {
        setArrowPre(<FontAwesomeIcon icon={faPlus} />);
      }
    }
  };

  useEffect(() => {
    if (EMRData.length !== 0) {
      //console.log("EMRData::"+JSON.stringify(EMRData));
    }
  }, [EMRData]);

  //상병, 검사 코드 목록 가져오기
  const getSTPCodeMaster = async () => {
    try {
      const response = await axios.get(`${getServerBaseUrl()}/api/v1/checklist/getSTPCodeList`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSangCodeData(response.data.patientSang);
      setTestCodeData(response.data.patientTest);
      setPreCodeData(response.data.patientPrescription);
    } catch (error) {
      console.error("getSTPCodeList error:", error);
      Swal.fire({
        title: "오류",
        text: "데이터를 가져오는 중 오류가 발생했습니다.",
        icon: "error",
        showConfirmButton: true,
        customClass: {
          popup: "custom-swal-popup",
        },
      });
    }
  };

  const searchPatientList = async () => {
    setIsOpenPatientInfo(false);
    setShowPreviewSave(false);
    setPatientInfo({});
    setSearched(true);
    let patientName = "";
    if (EMRData.patientName === undefined || EMRData.patientName === null) {
      patientName = "";
    } else {
      patientName = EMRData.patientName;
    }

    let birthday = "";
    if (EMRData.birthday === undefined || EMRData.birthday === null) {
      birthday = "";
    } else {
      birthday = EMRData.birthday;
    }

    let receptionDate = "";
    if (EMRData.receptionDate === undefined || EMRData.receptionDate === null) {
      receptionDate = "";
    } else {
      receptionDate = EMRData.receptionDate;
    }

    try {
      const params = {
        hospital_id: hospitalId,
        patient_name: patientName,
        birth_date: birthday,
        reception_date: receptionDate,
      };

      // 데이터 로딩 인디케이터 표시
      Swal.fire({
        title: "데이터를 가져오는 중...",
        text: "잠시만 기다려 주세요.",
        didOpen: () => {
          Swal.showLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        customClass: {
          popup: "custom-loading-popup",
        },
      });

      const response = await axios.get(`${getServerBaseUrl()}/api/v1/checklist/getPatientListForDoctor`, {
        params: params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPatientList(response.data);
    } catch (error) {
      console.error("getPateintList error:", error);
      Swal.fire({
        title: "오류",
        text: "데이터를 가져오는 중 오류가 발생했습니다.",
        icon: "error",
        showConfirmButton: true,
        customClass: {
          popup: "custom-swal-popup",
        },
      });
    } finally {
      Swal.close();
    }
  };

  const getPatientWholeInfo = (patientId, recDate) => {
    Swal.fire({
      title: "데이터를 가져오는 중...",
      text: "잠시만 기다려 주세요.",
      didOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      customClass: {
        popup: "custom-loading-popup",
      },
    });
    if (patientId) {
      setPatientId(patientId);
      getPatientVITALAndInfoData(patientId, recDate);
      getPatientSTPData(patientId, recDate);

      // recDate가 오늘이고 treatmentCompleted가 N인 경우
      if (recDate.startsWith(today)) {
        setShowPreviewSave(true);
      } else {
        setShowPreviewSave(false);
      }

      Swal.close();
    }
  };

  const getPatientVITALAndInfoData = async (patientId, recDate) => {
    try {
      const response = await axios.get(`${getServerBaseUrl()}/api/v1/checklist/${patientId}/getPatientInfo`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { recDate },
      });
      setPatientInfo(response.data.patientInfo);
      setPatientVITAL(response.data.patientVital);
      setIsOpenPatientInfo(!isOpenPatientInfo);
    } catch (error) {
      console.error("get VITAL data error: ", error);
      Swal.fire({
        title: "오류",
        text: "데이터를 가져오는 중 오류가 발생했습니다.",
        icon: "error",
        showConfirmButton: true,
        customClass: {
          popup: "custom-swal-popup",
        },
      });
    }
  };

  const getPatientSTPData = async (patientId, recDate) => {
    try {
      const response = await axios.get(`${getServerBaseUrl()}/api/v1/checklist/getPatientSTP/${patientId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { recDate },
      });
      setPatientSang(response.data.patientSang);
      setPatientTest(response.data.patientTest);
      setPatientPrescription(response.data.patientPrescription);
    } catch (error) {
      console.error("get STP data error: ", error);
      Swal.fire({
        title: "오류",
        text: "데이터를 가져오는 중 오류가 발생했습니다.",
        icon: "error",
        showConfirmButton: true,
        customClass: {
          popup: "custom-swal-popup",
        },
      });
    }
  };

  //추가 버튼 STP 함수 공통.
  //STP: Sang, Test, Prescription 약자
  const addSTP = (flag) => {
    // 1. 상병 추가
    if (flag === "sang") {
      if (sangSearchTerm === "") {
        showWarningAlert("추가할 상병 코드유형을 선택해주세요.");
        return;
      }

      if (!sangAddData.code || !sangAddData.codeName) {
        showWarningAlert("상병 코드를 선택해주세요.");
        return;
      }

      // 새로운 배열을 생성하여 기존의 patientSang 배열과 새로운 값을 합칩니다.
      const updatedPatientSang = [...patientSang, { patientId: patientId, medicalChargeCode: sangAddData.code, medicalChargeCodeKo: sangAddData.codeName, ruleOut: "N" }];

      // setState나 useState를 통해 patientSang 상태를 업데이트합니다.
      setPatientSang(updatedPatientSang);
      setSangSearchTerm("");
      setSangAutoTemp([]);

      // 2. 검사 추가
    } else if (flag === "test") {
      if (testSearchTerm === "") {
        showWarningAlert("추가할 검사 유형을 선택해주세요.");
        return;
      }

      if (!testAddData.testCode || !testAddData.testName) {
        showWarningAlert("검사 코드를 선택해주세요.");
        return;
      }
      // 새로운 배열을 생성하여 기존의 patientSang 배열과 새로운 값을 합칩니다.
      const updatedPatientTest = [...patientTest, { patientId: patientId, insuranceClaimCode: testAddData.testCode, medicalChargeNameKo: testAddData.testName }];

      // setState나 useState를 통해 patientSang 상태를 업데이트합니다.
      setPatientTest(updatedPatientTest);
      setTestSearchTerm("");
      setTestAutoTemp([]);
      // 3. 처방 추가
    } else if (flag === "pre") {
      if (preSearchTerm === "") {
        showWarningAlert("추가할 처방 유형을 선택해주세요.");
        return;
      }

      if (!preAddData.testCode || !preAddData.testName) {
        showWarningAlert("처방 코드를 선택해주세요.");
        return;
      }
      // 새로운 배열을 생성하여 기존의 patientSang 배열과 새로운 값을 합칩니다.
      const updatedPatientPrescription = [...patientPrescription, { patientId: patientId, insuranceClaimCode: preAddData.code, medicalChargeNameKo: preAddData.codeName, type: preAddData.type }];

      // setState나 useState를 통해 patientSang 상태를 업데이트합니다.
      setPatientPrescription(updatedPatientPrescription);
      setPreSearchTerm("");
      setPreAutoTemp([]);
    }
  };

  //Sang 등록함수
  const addSang = async (patientId, sangData) => {
    try {
      const response = await axios.post(`/api/v1/DocEMR/insertSang/${patientId}/${userId}`, sangData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 201) {
        getPatientSTPData(patientId);
        setSangSearchTerm("");
      } else {
        console.error("Sang Insert error: ", response.statusText);
        Swal.fire({
          title: "오류",
          text: "상병을 등록하는 도중 오류가 발생했습니다.",
          icon: "error",
          customClass: {
            popup: "custom-swal-popup",
          },
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error("Sang Insert error: ", error);
      Swal.fire({
        title: "오류!",
        text: "상병을 등록하는 중 오류가 발생했습니다.",
        icon: "error",
        customClass: {
          popup: "custom-swal-popup",
        },
        showConfirmButton: true, // 사용자가 확인 버튼을 눌러야 닫힙니다.
      });
    }
  };

  //test 등록함수
  const addTest = async (patientId, testData) => {
    try {
      const response = await axios.post(`/api/v1/DocEMR/insertTest/${patientId}/${userId}`, testData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 201) {
        getPatientSTPData(patientId);
        setTestSearchTerm("");
      } else {
        console.error("Test Insert error: ", response.statusText);
        Swal.fire({
          title: "오류",
          text: "검사를 등록하는 도중 오류가 발생했습니다.",
          icon: "error",
          customClass: {
            popup: "custom-swal-popup",
          },
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error("Test Insert error: ", error);
      Swal.fire({
        title: "오류!",
        text: "검사 등록하는 중 오류가 발생했습니다.",
        icon: "error",
        customClass: {
          popup: "custom-swal-popup",
        },
        showConfirmButton: true, // 사용자가 확인 버튼을 눌러야 닫힙니다.
      });
    }
  };

  //prescription 등록함수
  const addPrescription = async (patientId, preData) => {
    try {
      const response = await axios.post(`/api/v1/DocEMR/insertPrescription/${patientId}/${userId}`, preData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 201) {
        getPatientSTPData(patientId);
        setPreSearchTerm("");
      } else {
        console.error("Test Insert error: ", response.statusText);
        Swal.fire({
          title: "오류",
          text: "검사를 등록하는 도중 오류가 발생했습니다.",
          icon: "error",
          customClass: {
            popup: "custom-swal-popup",
          },
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error("Test Insert error: ", error);
      Swal.fire({
        title: "오류!",
        text: "검사 등록하는 중 오류가 발생했습니다.",
        icon: "error",
        customClass: {
          popup: "custom-swal-popup",
        },
        showConfirmButton: true, // 사용자가 확인 버튼을 눌러야 닫힙니다.
      });
    }
  };

  //삭제 버튼 STP 함수 공통.
  //STP: Sang, Test, Prescription 약자
  const deleteSTP = async (flag, index) => {
    // const confirmationResult = await Swal.fire({
    //     icon: 'question',
    //     title: '삭제',
    //     text: '해당 목록을 삭제하시겠습니까?',
    //     showCancelButton:  true,
    //     confirmButtonText: '확인',
    //     cancelButtonText: '취소',
    //     customClass : {
    //         popup: 'custom-swal-popup',
    //     }
    // });

    //if(confirmationResult.isConfirmed) {
    if (flag === "sang") {
      // patientSang 배열에서 삭제하려는 요소를 제외한 새로운 배열 생성 sang.medicalChargeCode !== code || sang.medicalChargeCodeKo !== codeName && index
      const updatedPatientSang = patientSang.filter((sang, idx) => idx !== index);
      // setState나 useState를 통해 patientSang 상태를 업데이트합니다.
      setPatientSang(updatedPatientSang);
    } else if (flag === "test") {
      const updatedPatientTest = patientTest.filter((test, idx) => idx !== index);
      setPatientTest(updatedPatientTest);
    } else if (flag === "prescription") {
      const updatedPatientPre = patientPrescription.filter((pre, idx) => idx !== index);
      setPatientPrescription(updatedPatientPre);
    }
    //}
  };

  // 상병 삭제
  const deleteSang = async (id, patientId) => {
    try {
      const response = await axios.delete(`/api/v1/DocEMR/${id}/deleteSang`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 204) {
        getPatientSTPData(patientId);
        setSangSearchTerm("");
      } else {
        await Swal.fire({
          icon: "error",
          title: "실패",
          text: "삭제 실패. 다시 시도해주세요.",
          confirmButtonText: "확인",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    } catch (error) {
      console.error("Error deleting Sang:", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "상병 삭제 오류",
            text: responseData,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    }
  };

  // 검사 삭제
  const deleteTest = async (id, patientId) => {
    try {
      const response = await axios.delete(`/api/v1/DocEMR/${id}/deleteTest`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 204) {
        getPatientSTPData(patientId);
        setTestSearchTerm("");
      } else {
        await Swal.fire({
          icon: "error",
          title: "실패",
          text: "삭제 실패. 다시 시도해주세요.",
          confirmButtonText: "확인",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    } catch (error) {
      console.error("Error deleting Sang:", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "검사 삭제 오류",
            text: responseData,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    }
  };

  // 처방 삭제
  const deletePrescription = async (id, patientId) => {
    try {
      const response = await axios.delete(`/api/v1/DocEMR/${id}/deletePrescription`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 204) {
        getPatientSTPData(patientId);
        setPreSearchTerm("");
      } else {
        await Swal.fire({
          icon: "error",
          title: "실패",
          text: "삭제 실패. 다시 시도해주세요.",
          confirmButtonText: "확인",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    } catch (error) {
      console.error("Error deleting Prescription:", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "처방 삭제 오류",
            text: responseData,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    }
  };

  //EMR 버튼
  const clickEMRButton = async (submitType) => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 월은 0부터 시작하므로 +1을 해줍니다.
    const day = String(date.getDate()).padStart(2, "0");

    const formattedDate = `${year}${month}${day}`;

    const emrJsonData = {
      apiKey: "3QPQVnhaHUirjXjOu119hUkQ81uSTqla5ZBcwT7aYw3aAsIRnLBNqNYVBF7iOlHO",
      userId: userId,
      submitType: submitType,
      chartNo: patientInfo.chartNo,
      patientName: patientInfo.patientName,
      birthdate: patientInfo.birthDate,
      abortionExp: false,
      childBirthMethod: null,
      isMultipleFetus: false,
      pastHistory: patientInfo.pastHistory,
      familyHistory: patientInfo.emrFamilyHistory,
      presentIllness: patientInfo.emrPresentIllness,
      roCode: null,
      obHistory: {
        MRNO: patientInfo.chartNo,
        EDCD: patientInfo.birthDueDate.replace(/-/g, ""),
        FCNT: 1,
        WKSD: parseFloat(patientInfo.pregnantWeeks),
        LMDT: null,
        PRA1: 0,
        PRA2: 0,
        PRA3: 0,
        PRA4: 0,
        PRA5: 0,
        PRA6: 0,
        LADT: null,
      },
      deliveryHistory: [
        {
          MRNO: null,
          YEAR: null,
          YSEQ: 0,
          DLDT: null,
          IUPP: 0,
          WEGT: 0,
          HIGH: 0,
        },
      ],
      vital: {
        MRNO: patientInfo.chartNo,
        INDT: formattedDate,
        DEPT: "",
        CASE: 123113,
        BP01: patientVITAL !== null && patientVITAL.maxBloodPressure !== undefined ? patientVITAL.maxBloodPressure : 0,
        BP02: patientVITAL !== null && patientVITAL.minBloodPressure !== undefined ? patientVITAL.minBloodPressure : 0,
        WEGT: patientVITAL !== null && patientVITAL.weight !== undefined ? patientVITAL.weight : 0,
        HEAT: patientVITAL !== null && patientVITAL.temperature !== undefined ? patientVITAL.temperature : 0,
        HIGT: patientVITAL !== null && patientVITAL.height !== undefined ? patientVITAL.height : 0,
        HEAD: patientVITAL !== null && patientVITAL.head !== undefined ? patientVITAL.head : 0,
        GLUC: patientVITAL !== null && patientVITAL.bloodGlucose !== undefined ? patientVITAL.bloodGlucose : "0",
        PRCT: patientVITAL !== null && patientVITAL.pulseRate !== undefined ? patientVITAL.pulseRate : "0",
      },
      chart: {
        MRNO: null,
        INDT: null,
        DEPT: null,
        CASE: null,
        TEXT: null,
      },
      medicalCharge: [],
    };

    if (patientSang.length !== 0) {
      for (var i = 0; i < patientSang.length; i++) {
        var obj = {
          INDT: formattedDate,
          DEPT: "OB",
          CASE: 123113,
          TYPE: "SANG",
          CODE: patientSang[i].medicalChargeCode,
          HDSC: patientSang[i].medicalChargeCodeKo,
          EDSC: patientSang[i].medicalChargeCodeEn,
          GCOD: "",
          SELF: "",
          RULE: patientSang[i].ruleOut === "Y" ? "R" : "",
        };

        emrJsonData.medicalCharge.push(obj);
      }
    }

    if (patientTest.length !== 0) {
      for (var i = 0; i < patientTest.length; i++) {
        var obj = {
          INDT: formattedDate,
          DEPT: "OB",
          CASE: "",
          TYPE: "TEST",
          CODE: "",
          HDSC: patientTest[i].medicalChargeNameKo,
          EDSC: patientTest[i].medicalChargeNameEn,
          GCOD: patientTest[i].insuranceClaimCode,
          SELF: "",
          RULE: "",
        };

        emrJsonData.medicalCharge.push(obj);
      }
    }

    if (patientPrescription.length !== 0) {
      for (var i = 0; i < patientPrescription.length; i++) {
        var obj = {
          INDT: formattedDate,
          DEPT: "OB",
          CASE: "",
          TYPE: patientPrescription[i].type,
          CODE: "",
          HDSC: patientPrescription[i].medicalChargeNameKo,
          EDSC: patientPrescription[i].medicalChargeNameEn,
          GCOD: patientPrescription[i].insuranceClaimCode,
          SELF: "",
          RULE: "",
        };

        emrJsonData.medicalCharge.push(obj);
      }
    }
    try {
      const response = await axios.post(`/api/v2/emr/processEmrData`, emrJsonData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200 && submitType === "save") {
        Swal.fire({
          icon: "success",
          title: "성공",
          text: "환자 데이터가 저장되었습니다.",
          customClass: {
            popup: "custom-swal-popup",
          },
        }).then(() => {
          setIsOpenPatientInfo(false);
          setShowPreviewSave(false);
          setSearched(false);
          setPatientInfo({});
          setPatientList([]);
          setEMRData({
            patientName: "",
            birthday: "",
          });
        });
      }
    } catch (error) {
      console.error("Error process EMR:", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "EMR 오류",
            text: responseData,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    }
  };

  const showWarningAlert = (text) => {
    Swal.fire({
      icon: "warning",
      title: "알림",
      text: text,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };

  const handleCheckboxChange = (e, index) => {
    const { checked } = e.target;
    const updatedSang = [...patientSang]; // 기존 상태 배열 복사
    updatedSang[index] = { ...updatedSang[index], ruleOut: checked ? "Y" : "N" }; // 해당 항목의 ruleOut 업데이트
    setPatientSang(updatedSang); // patientSang 상태 업데이트
  };

  useEffect(() => {
    if (isOpenPatientInfo) {
      const tooltipElement = document.getElementById("familyHistoryTooltip");
      const tooltipElementPast = document.getElementById("pastHistoryTooltip");
      const tooltipElementPresent = document.getElementById("presentIllnessTooltip");

      // 툴팁을 활성화하는 함수
      function activateTooltip() {
        const fullText = patientInfo.emrFamilyHistory; // 여기서 원하는 전체 내용을 삽입해야 합니다.
        tooltipElement.setAttribute("title", fullText);
      }

      function activateTooltipPast() {
        const fullText = patientInfo.pastHistory;
        tooltipElementPast.setAttribute("title", fullText);
      }

      function activateTooltipPresent() {
        const fullText = patientInfo.emrPresentIllness;
        tooltipElementPresent.setAttribute("title", fullText);
      }

      // 툴팁 활성화 여부 확인 (가족력)
      if (patientInfo.emrFamilyHistory && typeof patientInfo.emrFamilyHistory === "string" && patientInfo.emrFamilyHistory.length > 10 && tooltipElement !== null) {
        activateTooltip();
      }

      // 툴팁 활성화 여부 확인 (과거력)
      if (patientInfo.pastHistory && typeof patientInfo.pastHistory === "string" && patientInfo.pastHistory.length > 10 && tooltipElementPast !== null) {
        activateTooltipPast();
      }

      // 툴팁 활성화 여부 확인 (현병력)
      if (patientInfo.emrPresentIllness && typeof patientInfo.emrPresentIllness === "string" && patientInfo.emrPresentIllness.length > 10 && tooltipElementPresent !== null) {
        activateTooltipPresent();
      }
    }
  }, [isOpenPatientInfo]);

  return (
    <div className="EMR-Register-container">
      <HeaderText />
      <div className="EMR-search-box">
        <div className="EMR-search-content">
          <label>접수일 </label>
          <input type="date" className="reception-date" id="receptionDate" name="receptionDate" placeholder="접수일을 선택해주세요." value={EMRData.receptionDate || today} onChange={handleChange} />
          <label>환자명 </label>
          <input type="text" className="patient-name-birth-date" id="patientNameID" name="patientName" placeholder="환자명을 입력해주세요." value={EMRData.patientName} onChange={handleChange} />
          <label>생년월일 </label>
          <input type="text" className="patient-name-birth-date" id="birthDayID" name="birthday" placeholder="생년월일을 입력해주세요." value={EMRData.birthday} onChange={handleChange} />
          <button className="EMR-search-btn" onClick={searchPatientList}>
            검색
          </button>
        </div>
        <div className="EMR-info-text">
          <FontAwesomeIcon icon={faCircleInfo} />
          <span>&nbsp;지금 진료하고 있는 환자를 검색해 주세요.</span>
        </div>
      </div>
      <div className="EMR-Register-body">
        <div className={arrowPatientList.type === FontAwesomeIcon && arrowPatientList.props.icon === faMinus ? "EMR-patient-list" : "EMR-tab-fold"}>
          <div className="EMR-body-title" onClick={() => pageSpredOrNot(arrowPatientList, "환자목록")}>
            <label>환자목록</label>
            <label style={{ cursor: "pointer", fontSize: "14px" }} className="EMR-spread-btn">
              {arrowPatientList}
            </label>
          </div>
          {arrowPatientList.type === FontAwesomeIcon && arrowPatientList.props.icon === faMinus && (
            <div className="patient-list-card">
              <div className="EMR-wrapper">
                <div className="EMR-custom-table gap-setting">
                  <div className="row header4">
                    <div className="cell text-center text12-size">환자명</div>
                    <div className="cell text-center text12-size">생년월일</div>
                    <div className="cell text-center text12-size">임신주수</div>
                    <div className="cell text-center text12-size">담당의</div>
                    <div className="cell text-center text12-size">진료여부</div>
                  </div>
                  {patientList.length !== 0
                    ? patientList.map((patient, index) => (
                        <div
                          className={`${index % 2 === 0 ? "row row-hovered" : "row-colored bbs-click-style row-hovered"}`}
                          key={index}
                          onClick={() => getPatientWholeInfo(patient.patientId, patient.recDate)}
                          style={{ color: patient.treatmentCompleted === "Y" ? "gray" : "black" }}
                        >
                          <div className="cell text-center bbs-click-style text12-size">{`${patient.patientName}`}</div>
                          <div className="cell text-center bbs-click-style text12-size">{`${patient.birthDate}`}</div>
                          <div className="cell text-center bbs-click-style text12-size">{`${patient.pregnantWeeks}`}주</div>
                          <div className="cell text-center bbs-click-style text12-size">{`${patient.doctorName === null ? "" : patient.doctorName}`}</div>
                          <div className="cell text-center bbs-click-style text12-size">{patient.treatmentCompleted === "Y" ? "진료 완료" : "진료 대기 중"}</div>
                        </div>
                      ))
                    : null}
                </div>
                {patientList.length == 0 && searched == true ? (
                  <div className="text-center" style={{ padding: "20px 0 0 0" }}>
                    조회 결과가 없습니다.
                  </div>
                ) : null}
              </div>
            </div>
          )}
        </div>
        {isOpenPatientInfo && (
          <div>
            <div className={arrowBasicInfo.type === FontAwesomeIcon && arrowBasicInfo.props.icon === faMinus ? "EMR-patient-bInfo" : "EMR-tab-fold"}>
              <div className="EMR-body-title" onClick={() => pageSpredOrNot(arrowBasicInfo, "기본정보")}>
                <label>기본정보 (ChartNo. {patientInfo.chartNo !== undefined ? patientInfo.chartNo : "0000000"})</label>
                <label style={{ cursor: "pointer", fontSize: "14px" }} className="EMR-spread-btn">
                  {arrowBasicInfo}
                </label>
              </div>
              {arrowBasicInfo.type === FontAwesomeIcon && arrowBasicInfo.props.icon === faMinus && (
                <div className="EMR-patient_basicInfo">
                  {/* <div className="EMR-card-header">
                                    ChartNo. {patientInfo.chartNo !== undefined ? patientInfo.chartNo : "0000000"} 
                                </div> */}
                  <div className="EMR-card-body">
                    <div className="EMR-basicInfo-table">
                      <div className="row header4">
                        <div className="EMR-cell text-center">이름</div>
                        <div className="cell-white">{patientInfo.patientName !== undefined ? patientInfo.patientName : ""}</div>
                        <div className="EMR-cell">나이</div>
                        <div className="cell-white">{patientInfo.age !== undefined ? patientInfo.age : ""}세</div>
                        <div className="EMR-cell">생년월일</div>
                        <div className="cell-white">{patientInfo.birthDate !== undefined ? patientInfo.birthDate : ""}</div>
                      </div>
                    </div>
                    <div className="EMR-basicInfo-table">
                      <div className="row header4">
                        <div className="EMR-cell">분만형태</div>
                        <div className="cell-white">{patientInfo.surgeryType !== undefined && patientInfo.surgeryType === "CS" ? "제왕절개" : "자연분만"}</div>
                        <div className="EMR-cell">임신 주수</div>
                        <div className="cell-white">{patientInfo.pregnantWeeks !== undefined ? patientInfo.pregnantWeeks : ""}주</div>
                        <div className="EMR-cell">분만 예정일</div>
                        <div className="cell-white">{patientInfo.birthDueDate !== undefined ? patientInfo.birthDueDate : ""}</div>
                      </div>
                    </div>
                    <div className="EMR-basicInfo-table">
                      <div className="row header4">
                        <div className="EMR-cell">현병력</div>
                        <div className="cell-white" style={{ fontSize: "12px" }} id="presentIllnessTooltip">
                          {patientInfo.emrPresentIllness && typeof patientInfo.emrPresentIllness === "string"
                            ? patientInfo.emrPresentIllness.length > 10
                              ? patientInfo.emrPresentIllness.slice(0, 7) + "..."
                              : patientInfo.emrPresentIllness
                            : ""}
                        </div>
                        <div className="EMR-cell">가족력</div>
                        <div className="cell-white" style={{ fontSize: "12px" }} id="familyHistoryTooltip">
                          {patientInfo.emrFamilyHistory && typeof patientInfo.emrFamilyHistory === "string"
                            ? patientInfo.emrFamilyHistory.length > 10
                              ? patientInfo.emrFamilyHistory.slice(0, 7) + "..."
                              : patientInfo.emrFamilyHistory
                            : ""}
                        </div>
                        <div className="EMR-cell">과거력</div>
                        <div className="cell-white" style={{ fontSize: "12px" }} id="pastHistoryTooltip">
                          {patientInfo.pastHistory && typeof patientInfo.pastHistory === "string"
                            ? patientInfo.pastHistory.length > 10
                              ? patientInfo.pastHistory.slice(0, 7) + "..."
                              : patientInfo.pastHistory
                            : ""}
                        </div>
                      </div>
                    </div>
                    <div className="EMR-basicInfo-table-only2">
                      <div className="row header4">
                        <div className="EMR-cell-with-bc">초산여부</div>
                        <div className="cell-white" style={{ fontSize: "12px" }} id="presentIllnessTooltip">
                          {patientInfo.isFirstChildbirth !== null && patientInfo.isFirstChildbirth !== false ? "초산" : "경산"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className={arrowVital.type === FontAwesomeIcon && arrowVital.props.icon === faMinus ? "EMR-patient-vital" : "EMR-tab-fold"}>
              <div className="EMR-body-title" onClick={() => pageSpredOrNot(arrowVital, "바이탈")}>
                <label>바이탈</label>
                <label style={{ cursor: "pointer", fontSize: "14px" }} className="EMR-spread-btn">
                  {arrowVital}
                </label>
              </div>
              {arrowVital.type === FontAwesomeIcon && arrowVital.props.icon === faMinus && (
                <div className="vital-table-container">
                  <div className="EMR-vital-wrapper" style={{ width: "100%" }}>
                    <div className="EMR-custom-table gap-setting">
                      <div className="row header4">
                        <div className="cell text12-size" style={{ textAlign: "center" }}>
                          키
                        </div>
                        <div className="cell text12-size" style={{ textAlign: "center" }}>
                          몸무게
                        </div>
                        <div className="cell text12-size" style={{ textAlign: "center" }}>
                          체온
                        </div>
                        <div className="cell text12-size" style={{ textAlign: "center" }}>
                          BMI 지수
                        </div>
                        <div className="cell text12-size" style={{ textAlign: "center" }}>
                          수축기 혈압
                        </div>
                        <div className="cell text12-size" style={{ textAlign: "center" }}>
                          이완기 혈압
                        </div>
                        <div className="cell text12-size" style={{ textAlign: "center" }}>
                          혈당
                        </div>
                      </div>
                      {patientVITAL && (
                        <div className="row row-hovered">
                          <div className="cell text-center cell-small-font">{`${patientVITAL.height ? `${patientVITAL.height}cm` : "-"}`}</div>
                          <div className="cell text-center cell-small-font">{`${patientVITAL.weight ? `${patientVITAL.weight}kg` : "-"}`}</div>
                          <div className="cell text-center cell-small-font">{`${patientVITAL.temperature ? `${patientVITAL.temperature}°C` : "-"}`}</div>
                          <div className="cell text-center cell-small-font">{`${patientVITAL.bmi ? patientVITAL.bmi : "-"}`}</div>
                          <div className="cell text-center cell-small-font">{`${patientVITAL.maxBloodPressure ? `${patientVITAL.maxBloodPressure}mmHg` : "-"}`}</div>
                          <div className="cell text-center cell-small-font">{`${patientVITAL.minBloodPressure ? `${patientVITAL.minBloodPressure}mmHg` : "-"}`}</div>
                          <div className="cell text-center cell-small-font">{`${patientVITAL.bloodGlucose ? `${patientVITAL.bloodGlucose}mg/dl` : "-"}`}</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className={arrowSang.type === FontAwesomeIcon && arrowSang.props.icon === faMinus ? "EMR-sang-list" : "EMR-tab-fold"}>
              <div className="EMR-body-title2" onClick={() => pageSpredOrNot(arrowSang, "상병")}>
                <div>
                  <label>상병</label>
                </div>
                <div className="right-container">
                  <div className="common-search-container">
                    <div className="common-search" onClick={(e) => e.stopPropagation()}>
                      <span className="magnifyGlass-icon">
                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                      </span>
                      <input type="text" id="sangCodeId" name="sangCode" placeholder="질병코드/질병명" value={sangSearchTerm} onChange={handleSangAutoInputChange} />
                      <button className="EMR-add-button" onClick={() => addSTP("sang")}>
                        추가
                      </button>
                    </div>
                    {/* 자동완성 결과 표시 */}
                    <ul className="EMR-sang-auto-complete-options" onClick={(e) => e.stopPropagation()}>
                      {sangAutoTemp.map((sangAuto, aIndex) => (
                        <li key={aIndex} onClick={() => handleSangAutoCompleteSelect(sangAuto)}>
                          {sangAuto.code}&nbsp;&nbsp;{sangAuto.codeName}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <label style={{ cursor: "pointer", fontSize: "14px" }} className="EMR-spread-btn">
                    {arrowSang}
                  </label>
                </div>
              </div>
              {arrowSang.type === FontAwesomeIcon && arrowSang.props.icon === faMinus && (
                <div className="EMR-sang-wrapper sang-list">
                  <div className="EMR-custom-table gap-setting">
                    <div className="row header">
                      <div className="EMR-common-table-cell text12-size" style={{ textAlign: "center", width: "60px" }}>
                        질병 코드
                      </div>
                      <div className="EMR-common-table-cell text12-size" style={{ textAlign: "center" }}>
                        질병명
                      </div>
                      <div className="EMR-common-table-cell text12-size" style={{ textAlign: "center", width: "55px" }}>
                        의증여부
                      </div>
                      <div className="EMR-common-table-cell text12-size" style={{ textAlign: "center", width: "55px" }}>
                        삭제
                      </div>
                    </div>
                    {patientSang.map(
                      (
                        sang,
                        index //공지 데이터는 따로 수정
                      ) => (
                        <div className={`${index % 2 === 0 ? "row row-hovered" : "row-colored bbs-click-style row-hovered"}`} key={index}>
                          <div className="EMR-common-table-cell text-center text12-size">{`${sang.medicalChargeCode}`}</div>
                          <div className="EMR-common-table-cell text12-size" style={{ textAlign: "left" }}>{`${sang.medicalChargeCodeKo}`}</div>
                          <div className="EMR-common-table-cell text-center text12-size">
                            <input
                              type="checkbox"
                              name={sang.medicalChargeCodeKo}
                              id={sang.medicalChargeCodeKo + index}
                              checked={sang.ruleOut === "Y"}
                              onChange={(e) => handleCheckboxChange(e, index)}
                            />
                          </div>
                          <div className="EMR-common-table-cell text-center text12-size">
                            <span className="trashcan-icon" onClick={() => deleteSTP("sang", index)}>
                              <FontAwesomeIcon icon={faTrashCan} />
                            </span>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className={arrowTest.type === FontAwesomeIcon && arrowTest.props.icon === faMinus ? "EMR-test-list" : "EMR-tab-fold"}>
              <div className="EMR-body-title2" onClick={() => pageSpredOrNot(arrowTest, "검사")}>
                <div>
                  <label>검사</label>
                </div>
                <div className="right-container">
                  <div className="common-search-container">
                    <div className="common-search" onClick={(e) => e.stopPropagation()}>
                      <span className="magnifyGlass-icon">
                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                      </span>
                      <input type="text" id="testCodeId" name="testCode" placeholder="청구코드/검사명" value={testSearchTerm} onChange={handleTestAutoInputChange} />
                      <button className="EMR-add-button" onClick={() => addSTP("test")}>
                        추가
                      </button>
                    </div>
                    {/* 자동완성 결과 표시 */}
                    <ul className="EMR-sang-auto-complete-options" onClick={(e) => e.stopPropagation()}>
                      {testAutoTemp.map((testAuto, tIndex) => (
                        <li key={tIndex} onClick={() => handleTestAutoCompleteSelect(testAuto)}>
                          {testAuto.testCode}&nbsp;&nbsp;{testAuto.masterName}&nbsp;&nbsp;{testAuto.testName}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <label style={{ cursor: "pointer", fontSize: "14px" }} className="EMR-spread-btn">
                    {arrowTest}
                  </label>
                </div>
              </div>
              {arrowTest.type === FontAwesomeIcon && arrowTest.props.icon === faMinus && (
                <div className="EMR-sang-wrapper test-list">
                  <div className="EMR-custom-table gap-setting">
                    <div className="row header3">
                      <div className="EMR-common-table-cell text-center text12-size" style={{ width: "55px" }}>
                        청구코드
                      </div>
                      <div className="EMR-common-table-cell text-center text12-size">검사명</div>
                      <div className="EMR-common-table-cell text-center text12-size" style={{ width: "55px" }}>
                        삭제
                      </div>
                    </div>
                    {patientTest.map(
                      (
                        test,
                        tIndex //공지 데이터는 따로 수정
                      ) => (
                        <div className={`${tIndex % 2 === 0 ? "row row-hovered" : "row-colored bbs-click-style row-hovered"}`} key={tIndex}>
                          <div className="EMR-common-table-cell text-center text12-size">{`${
                            test.insuranceClaimCode === null || test.insuranceClaimCode === undefined ? "" : test.insuranceClaimCode
                          }`}</div>
                          <div className="EMR-common-table-cell text12-size" style={{ textAlign: "left" }}>{`${
                            test.medicalChargeNameKo === null || test.medicalChargeNameKo === undefined ? "" : test.medicalChargeNameKo
                          }`}</div>
                          <div className="EMR-common-table-cell text-center text12-size">
                            <span className="trashcan-icon" onClick={() => deleteSTP("test", tIndex)}>
                              <FontAwesomeIcon icon={faTrashCan} />
                            </span>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className={arrowPre.type === FontAwesomeIcon && arrowPre.props.icon === faMinus ? "EMR-pre-list" : "EMR-tab-fold"}>
              <div className="EMR-body-title2" onClick={() => pageSpredOrNot(arrowPre, "처방")}>
                <div>
                  <label>처방</label>
                </div>
                <div className="right-container">
                  <div className="common-search-container">
                    <div className="common-search" onClick={(e) => e.stopPropagation()}>
                      <span className="magnifyGlass-icon">
                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                      </span>
                      <input type="text" id="preCodeId" name="preCode" placeholder="청구코드/처방" value={preSearchTerm} onChange={handlePreAutoInputChange} />
                      <button className="EMR-add-button" onClick={() => addSTP("pre")}>
                        추가
                      </button>
                    </div>
                    {/* 자동완성 결과 표시 */}
                    <ul className="EMR-sang-auto-complete-options" onClick={(e) => e.stopPropagation()}>
                      {preAutoTemp.map((preAuto, pIndex) => (
                        <li key={pIndex} onClick={() => handlePreAutoCompleteSelect(preAuto)}>
                          {preAuto.code}&nbsp;&nbsp;{preAuto.codeName}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <label style={{ cursor: "pointer", fontSize: "14px" }} className="EMR-spread-btn">
                    {arrowPre}
                  </label>
                </div>
              </div>
              {arrowPre.type === FontAwesomeIcon && arrowPre.props.icon === faMinus && (
                <div className="EMR-sang-wrapper pre-list">
                  <div className="EMR-custom-table gap-setting">
                    <div className="row header2">
                      <div className="EMR-common-table-cell text12-size" style={{ textAlign: "center", width: "90px" }}>
                        청구코드
                      </div>
                      <div className="EMR-common-table-cell text12-size" style={{ textAlign: "center" }}>
                        처방내용
                      </div>
                      <div className="EMR-common-table-cell text12-size" style={{ textAlign: "center", width: "55px" }}>
                        삭제
                      </div>
                    </div>
                    {patientPrescription.map(
                      (
                        presc,
                        pIndex //공지 데이터는 따로 수정
                      ) => (
                        <div className={`${pIndex % 2 === 0 ? "row row-hovered" : "row-colored bbs-click-style row-hovered"}`} key={pIndex}>
                          <div className="EMR-common-table-cell text-center text12-size">{`${
                            presc.insuranceClaimCode === null || presc.insuranceClaimCode === "" || presc.insuranceClaimCode === undefined ? "" : presc.insuranceClaimCode
                          }`}</div>
                          <div className="EMR-common-table-cell text12-size" style={{ textAlign: "left" }}>{`${
                            presc.medicalChargeNameKo === null || presc.medicalChargeNameKo === "" || presc.medicalChargeNameKo === undefined ? "" : presc.medicalChargeNameKo
                          }`}</div>
                          <div className="EMR-common-table-cell text-center text12-size">
                            <span className="trashcan-icon" onClick={() => deleteSTP("prescription", pIndex)}>
                              <FontAwesomeIcon icon={faTrashCan} />
                            </span>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div className="EMR-Register-footer">
        {isOpenPatientInfo && showPreviewSave ? (
          <div>
            <button style={{ backgroundColor: "rgb(26 103 219)" }} onClick={() => clickEMRButton("preview")}>
              Preview
            </button>
            <button style={{ backgroundColor: "#27ae60" }} onClick={() => clickEMRButton("save")}>
              Save
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default EMRRegister;
